export default __webpack_public_path__ + "static/media/karken.9f807011.svg";